import React from 'react';
import { UsersFilterShape } from '../../../core/models/user';
import './FilterSummary.css';

const FILTER_LABELS: Record<string, string> = {
    hasPayedSubscription: 'Оплатившие подписку',
    hasSubscription: 'Есть подписка',
    subIsOver: 'Подписка закончилась',
    subExpiresInDays: 'Подписка закончится через (дней)',
    inUserIds: 'User UUIDs',
    inTgIds: 'TG IDs',
    inTgName: 'TG Names',
};

export function isFilterApplied(filter: UsersFilterShape | undefined): boolean {
    if (!filter || typeof filter !== 'object') return false;
    return Object.entries(filter).some(([, v]) =>
        v !== undefined && v !== null && !(Array.isArray(v) && v.length === 0)
    );
}

function getFilterEntries(filter: UsersFilterShape): Array<{ key: string; label: string; value: string }> {
    return Object.entries(filter)
        .filter(([, v]) => v !== undefined && v !== null && !(Array.isArray(v) && v.length === 0))
        .map(([key, v]) => {
            const label = FILTER_LABELS[key] ?? key;
            const value = Array.isArray(v) ? v.join(', ') : String(v === true ? 'Да' : v === false ? 'Нет' : v);
            return { key, label, value };
        });
}

interface FilterSummaryProps {
    filter?: UsersFilterShape;
    title?: string;
    className?: string;
}

export const FilterSummary: React.FC<FilterSummaryProps> = ({
    filter,
    title = 'Активный фильтр:',
    className = '',
}) => {
    if (!isFilterApplied(filter)) return null;

    const entries = getFilterEntries(filter!);
    if (entries.length === 0) return null;

    return (
        <div className={`filter-summary ${className}`.trim()}>
            <span className="filter-summary-title">{title}</span>
            <table className="filter-summary-table">
                <tbody>
                    {entries.map(({ key, label, value }) => (
                        <tr key={key}>
                            <td className="filter-summary-param">{label}</td>
                            <td className="filter-summary-value">{value}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default FilterSummary;
